import { Stack, StackProps, styled } from '@mui/material';

interface PaperStyledStyledProps extends StackProps {
  attr?: { noPadding?: boolean; fullHeight?: boolean };
}

export const PaperStyledStyled = styled(Stack)<PaperStyledStyledProps>(
  ({ theme, attr: { noPadding, fullHeight } = {} }) => ({
    padding: theme.spacing(noPadding ? 0 : 2),
    height: fullHeight ? '100%' : 'auto',
    borderRadius: theme.spacing(1),
    backgroundColor: theme.palette.white.main,
  }),
);
